import React, { useEffect, useState } from 'react'
import { Select } from 'antd'
import unionBy from 'lodash/unionBy'

export function SelectOrphanOptions({ value, onChange }) {
  const [items, setItems] = useState([])

  useEffect(() => {
    init()
  }, [])
  async function init() {
    const res = await searchOrphanOptions()
    setItems(res)
  }

  function onChangeOption(id) {
    // Necessary to return the name and the type
    onChange(items.find((item) => item.id === id))
  }

  if (!items) return null

  return (
    <Select
      key="orphan-options"
      showSearch
      style={{ width: '100%' }}
      placeholder="Please select an option"
      defaultValue={value?.length ? value : undefined}
      filterOption={(input, option) =>
        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
      onChange={onChangeOption}
    >
      {items.map((item) => (
        <Select.Option key={item.id} value={item.id}>
          {item.name}
        </Select.Option>
      ))}
    </Select>
  )
}

export async function searchOrphanOptions() {
  const res = await fetch('/db/guillotina/@list-orphan-opciones').then((res) =>
    res.json()
  )
  return unionBy(
    res?.products?.map?.((item) => ({
      ...item,
      // id and name are required by antd
      id: item.grupo,
      name: item.nombre,
    })),
    'id'
  )
}
